export default __webpack_public_path__ + "static/media/daniel_bar.a3697fbd.png";